<template>
        <el-container>
            <el-header height="15%">
                <div class="row mt-4">
                    <h4>E-mail для рассылки</h4>
                </div>
            </el-header>
            <el-main height="80%">
                <el-form aria-label="" label-width="140px" label-position="left">
                    <el-row>                        
                        <el-col :lg="12" :xl="8">
                            <el-form-item label="Сортировка">
                                <el-select v-model="query.sort" :width="300" @change="fetch()" placeholder="сортировка">
                                    <el-option
                                    v-for="item in sortConfig"
                                    :key="item.field"
                                    :value="item.field"
                                    :label="item.title"
                                    />
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>

                <el-table
                        :data="items"
                        style="width: 100%"
                        empty-text="Нет данных">
                    <el-table-column
                            prop="id"
                            label="Id"
                            width="50">
                    </el-table-column>
                    <el-table-column
                            prop="email"
                            label="E-mail"
                            width="450"
                    >
                    </el-table-column>   
                    <el-table-column
                            prop="created_at"
                            label="Дата создания"
                            width="450"
                    >
                    <template #default="scope">
                      {{ getHumanDate(scope.row.created_at) }}
                    </template>
                    </el-table-column>                   
                </el-table>
            </el-main>
            <el-footer height="5%">
              <el-pagination
                v-if="meta"
                background
                layout="prev, pager, next"
                :total="meta.total"
                :current-page.sync="meta.current_page"
                @current-change="getPage(meta.current_page)"
                :hide-on-single-page="true"
                :page-size="meta.per_page"
                :page-count="meta.last_page"
              >
              </el-pagination>
            </el-footer>
        </el-container>
</template>

<script>
import axios from "axios";
import { SETPRELOADER_STATE } from '@/store/mutation-types'

export default {
    name: "Comments",
    data: function(){
        const conf = [
                {
                  title: 'По названию (А-я)',
                  field: 'email.asc',
                  options: {
                    by: 'email',
                    order: 'asc'
                  }
                },
                {
                  title: 'По названию (Я-а)',
                  field: 'email.desc',
                  options: {
                    by: 'email',
                    order: 'desc'
                  }
                },
                {
                  title: 'По дате ↑',
                  field: 'created_at.asc',
                  options: {
                    by: 'created_at',
                    order: 'asc'
                  }
                },
                {
                  title: 'По дате ↓',
                  field: 'created_at.desc',
                  options: {
                    by: 'created_at',
                    order: 'desc'
                  }
                },
            ]
        return{
            items: [],
            sortConfig: conf,
            query: {
              sort: conf[3].field,
            },
            meta: [],
        }
    },
    mounted() {
        this.fetch();
    },
    computed: {
        activeSort() {
            const result = this.sortConfig.find((e) => e.field === this.query.sort)
            return result ? result.options  : undefined
        },
        queryComputed() {
            const sort = this.activeSort
            const result = {}
            let isChange = false;
            if (sort) {
                isChange = true
                result['sort'] = sort;
            }
            return isChange ? result : undefined
        }
    },
    methods:{
        getQuery(query) {
            const qs = require('qs');
            let q
            if (query) {
                q = query
            } else {
                q = this.queryComputed ? `?${qs.stringify(this.queryComputed)}` : ''
            }
            return q;
        },
        fetch(query){
          this.$store.commit(SETPRELOADER_STATE, true) 
          const q = this.getQuery(query)
          axios.get('email-subscribe' + q).then((response)=>{
             this.items = response.data.data;
             this.meta = response.data.meta;
          }).catch((errors)=>{
              if(errors.response.status === 401){
                  this.$router.push('/login');
              }
          })
          .finally(() => this.$store.commit(SETPRELOADER_STATE, false) );
        },
        
        getPage: function(pageNum){
            if(pageNum!==null){
                const qs = require('qs');
                const qProps = this.queryComputed ? `&${qs.stringify(this.activeSort)}` : undefined
                const q = `?page=${pageNum}${qProps}`
                this.fetch(q)
            }

        },
        getHumanDate(value){
            const date = new Date(value)
            if (date) {
                const  options = { year: 'numeric', month: 'short', day: 'numeric' };
                const result = date.toLocaleDateString('ru-Ru', options)
                return result 
            }
            return ''
        },
    }
}
</script>

<style scoped>

</style>